import type { Collection } from './models/collection';
import type { Database } from './models/database';
import type { OrderDirection, OrderSelector } from './orderBy';
import orderBy from './orderBy';

export default function sortDatabases(dbs: Database[], _orderBy: 'name' | 'size' | 'indexSize'): Database[] {
  let selectors: OrderSelector<Database | Collection>[] = [];
  let directions: OrderDirection[] = [];

  switch (_orderBy) {
    case 'name':
      selectors.push((item) => ('coll' in item ? item.coll : item.db));
      directions.push('asc');
      break;
    case 'size':
      selectors.push((item) => item.stats.storageStats.storageSize);
      directions.push('desc');
      break;
    case 'indexSize':
      selectors.push((item) => item.stats.storageStats.totalIndexSize);
      directions.push('desc');
      break;
  }

  selectors.push((item) => ('coll' in item ? item.coll : item.db));
  directions.push('asc');

  dbs = dbs.map((db) => ({
    ...db,
    collections: orderBy(db.collections, selectors, directions),
  }));

  return orderBy(dbs, selectors, directions);
}
